<template>
    <svg class="tile" viewBox="0 0 64 64" fill="none" aria-hidden="true" focusable="false">
        <rect class="wash" width="64" height="64" rx="3" />
        <circle class="disc-back" cx="35.4418" cy="29.593" r="11.5575" />
        <circle class="disc-front" cx="28.6019" cy="34.4269" r="11.5575" />
        <defs>
            <clipPath :id="`${uid}-back`"><circle cx="35.4418" cy="29.593" r="11.5575" /></clipPath>
        </defs>
        <!-- Paint the overlap explicitly rather than blending, and clip with a document-unique id so a
             second tile on the page cannot reference this one's circle.
             -->
        <g :clip-path="`url(#${uid}-back)`">
            <circle class="overlap" cx="28.6019" cy="34.4269" r="11.5575" />
        </g>
    </svg>
</template>

<script setup lang="ts">
/** The collaboration profile ask's tile on the coaching setup home card. Decorative: the card names the ask in text. */
import { useId } from "vue";

const uid = useId();
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    .tile {
        @apply block size-16 shrink-0;
    }

    .wash {
        fill: var(--color-setup-tile-profile-wash);
    }

    .disc-back {
        fill: var(--color-setup-tile-profile-back);
    }

    .disc-front {
        fill: var(--color-setup-tile-profile-front);
    }

    .overlap {
        fill: var(--color-setup-tile-profile-over);
    }
}
</style>
